const notifications = {
  search_contacts: 'Téléphone / Courriel',
};

export default notifications;
